import { BaseApiClient } from '../client'

export interface DiscordStatus {
  connected: boolean
  guildId?: string
  guildName?: string
  connectedAt?: string
}

export interface DiscordChannel {
  id: string
  name: string
  categoryId: string | null
  categoryName: string | null
  position: number
}

export interface NotificationDestination {
  ruleId: string
  provider: string
  channelId: string
  channelName: string
  isActive: boolean
}

export interface NotificationEvent {
  eventType: string
  category: string
  label: string
  description: string
  destinations: NotificationDestination[]
}

export interface SaveRuleInput {
  eventType: string
  provider: string
  channelId: string
  channelName: string
  isActive: boolean
}

export interface SaveRulesResponse {
  created: number
  updated: number
  deleted: number
}

export class NotificationsApi extends BaseApiClient {
  // Discord Connection
  async getDiscordStatus() {
    return this.request<DiscordStatus>('/api/admin/discord/status')
  }

  async getDiscordConnectUrl() {
    return this.request<{ url: string }>('/api/admin/discord/connect-url')
  }

  async getDiscordChannels() {
    return this.request<DiscordChannel[]>('/api/admin/discord/channels')
  }

  async disconnectDiscord() {
    return this.request<{ success: boolean }>('/api/admin/discord/connection', {
      method: 'DELETE',
    })
  }

  async testDiscordChannel(channelId: string) {
    return this.request<{ success: boolean; error?: string }>('/api/admin/discord/test', {
      method: 'POST',
      body: JSON.stringify({ channelId }),
    })
  }

  // Notification Rules
  async getNotificationRules() {
    return this.request<NotificationEvent[]>('/api/admin/notification-rules')
  }

  async saveNotificationRules(rules: SaveRuleInput[]) {
    return this.request<SaveRulesResponse>('/api/admin/notification-rules', {
      method: 'PUT',
      body: JSON.stringify({ rules }),
    })
  }
}
